import React, { useMemo } from 'react';
import { GeoJSONLayer } from 'react-mapbox-gl';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';
import { CoordinatesExact } from '../../models/Coordinates';

const FlightPath = ({ coordinatesArray, visible }) => {
  const theme = useTheme();

  const sourceData = useMemo(
    () => ({
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: visible ? coordinatesArray.map(({ longitude, latitude }) => [longitude, latitude]) : [],
      },
      properties: {
        width: 5,
        color: theme.palette.map.flightPath,
      },
    }),
    [visible, coordinatesArray, theme.palette.map.flightPath]
  );

  return (
    <GeoJSONLayer
      id="flightPath"
      type="geojson"
      data={sourceData}
      lineLayout={{
        'line-join': 'round',
        'line-cap': 'round',
      }}
      linePaint={{
        'line-color': ['get', 'color'],
        'line-width': ['get', 'width'],
      }}
    />
  );
};

FlightPath.propTypes = {
  coordinatesArray: PropTypes.arrayOf(CoordinatesExact),
  visible: PropTypes.bool,
};

FlightPath.defaultProps = {
  coordinatesArray: [],
  visible: true,
};

export default React.memo(FlightPath);
